__webpack_require__.p = "/akreditasi/_next/";